import type { MediaProps } from '#/lib/sanity';
import type { SanityMedia } from '#/lib/sanity/queries/media';
import { cn } from '#/lib/utils';
import { Image } from '#/components/Image';
import { LottieAnimation } from '#/components/LottieAnimation';
import { VideoLoop } from '#/components/VideoLoop';

export type MediaComponentProps = {
  media?: SanityMedia;
  loopVideo?: boolean;
} & MediaProps;

export function MediaCaption({
  className,
  caption,
  textAlign = 'left',
}: {
  className?: string;
  caption: string;
  textAlign?: 'left' | 'center' | null;
}) {
  return (
    <figcaption
      className={cn(
        'mt-10 text-14 leading-116 text-grayscale-06 m:text-15 italic',
        className,
        textAlign === 'center' && 'text-center',
      )}
    >
      {caption}
    </figcaption>
  );
}

export function Media({ media, ...rest }: MediaComponentProps) {
  if (!media) return null;
  if (media._type === 'image') {
    return <Image image={media} {...rest} />;
  } else if (media._type === 'videoLoop') {
    return <VideoLoop video={media} loop={rest.loopVideo} {...rest} />;
  } else if (media._type === 'lottieAnimation') {
    return <LottieAnimation lottie={media} {...rest} />;
  }
}
